import mutations from './employabilityDoctorTemplate.mutations'
import actions from './employabilityDoctorTemplate.actions'
import getters from './employabilityDoctorTemplate.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
